module.exports = __webpack_public_path__ + "static/media/BeatrizYankelevichHeadshot.88025c4f.JPG";